(() => {
  if (window.eccoVariantSkuCheckout) return;

  const variantSkuPropertyName = 'SKU de variante';
  const storefrontRoot = window.Shopify?.routes?.root || '/';
  let syncPromise;

  const getRenderedLineProperties = () => {
    const propertiesByLineKey = new Map();

    document.querySelectorAll('[data-cart-line-key][data-variant-public-sku]').forEach((line) => {
      const lineKey = String(line.dataset.cartLineKey || '');
      const publicSku = String(line.dataset.variantPublicSku || '').trim();

      if (lineKey) {
        propertiesByLineKey.set(lineKey, {
          publicSku,
        });
      }
    });

    return propertiesByLineKey;
  };

  const fetchJson = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with status ${response.status}`);
    }

    return response.json();
  };

  const syncVariantSkus = () => {
    if (syncPromise) return syncPromise;

    syncPromise = (async () => {
      const cart = await fetchJson(`${storefrontRoot}cart.js`);
      const renderedProperties = getRenderedLineProperties();
      const itemsToUpdate = cart.items
        .filter((item) => {
          const properties = item.properties || {};
          if (!renderedProperties.has(item.key)) return false;

          const { publicSku } = renderedProperties.get(item.key);

          return (
            String(properties[variantSkuPropertyName] || '') !== publicSku ||
            Object.prototype.hasOwnProperty.call(properties, 'Nombre de producto') ||
            Object.prototype.hasOwnProperty.call(properties, 'SKU') ||
            Object.prototype.hasOwnProperty.call(properties, 'SKU de color')
          );
        })
        .reverse();

      for (const item of itemsToUpdate) {
        const properties = { ...(item.properties || {}) };
        const { publicSku } = renderedProperties.get(item.key);

        delete properties.SKU;
        delete properties['SKU de color'];
        delete properties['Nombre de producto'];
        if (publicSku) {
          properties[variantSkuPropertyName] = publicSku;
        } else {
          delete properties[variantSkuPropertyName];
        }

        await fetchJson(`${storefrontRoot}cart/change.js`, {
          method: 'POST',
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties,
          }),
        });
      }
    })();

    return syncPromise.finally(() => {
      syncPromise = undefined;
    });
  };

  const setControlLoading = (control, loading) => {
    if (!control) return;

    control.toggleAttribute('disabled', loading && control instanceof HTMLButtonElement);
    control.setAttribute('aria-disabled', String(loading));
    control.classList.toggle('loading', loading);
  };

  document.addEventListener('submit', async (event) => {
    const submitter = event.submitter;
    if (!(submitter instanceof HTMLButtonElement) || submitter.name !== 'checkout') return;
    if (submitter.dataset.variantSkuReady === 'true') return;

    event.preventDefault();
    if (submitter.dataset.variantSkuSyncing === 'true') return;

    submitter.dataset.variantSkuSyncing = 'true';
    setControlLoading(submitter, true);

    try {
      await syncVariantSkus();
      submitter.dataset.variantSkuReady = 'true';
      setControlLoading(submitter, false);
      event.target.requestSubmit(submitter);
    } catch (error) {
      console.error('Unable to synchronize variant SKUs before checkout.', error);
      setControlLoading(submitter, false);
      delete submitter.dataset.variantSkuSyncing;
    }
  });

  document.addEventListener('click', async (event) => {
    const checkoutLink = event.target.closest('a[href]');
    if (!checkoutLink) return;

    const checkoutUrl = new URL(checkoutLink.href, window.location.origin);
    if (!checkoutUrl.pathname.match(/\/checkout\/?$/)) return;

    event.preventDefault();
    if (checkoutLink.dataset.variantSkuSyncing === 'true') return;

    checkoutLink.dataset.variantSkuSyncing = 'true';
    setControlLoading(checkoutLink, true);

    try {
      await syncVariantSkus();
      window.location.assign(checkoutUrl.href);
    } catch (error) {
      console.error('Unable to synchronize variant SKUs before checkout.', error);
      setControlLoading(checkoutLink, false);
      delete checkoutLink.dataset.variantSkuSyncing;
    }
  });

  window.eccoVariantSkuCheckout = { sync: syncVariantSkus };

  if (window.location.pathname.match(/\/cart\/?$/) || document.querySelector('[data-cart-line-key]')) {
    syncVariantSkus().catch((error) => {
      console.error('Unable to synchronize variant SKUs in the cart.', error);
    });
  }
})();
